import React from "react"

export default function MiniLoader({ inverted = true }) {
  const useInverted = inverted ? "inverted" : ""
  return (
    <div style={{ width: "80px" }} className={`ui active inline loader tiny ${useInverted}`}></div>
  )
}
